import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div className="min-h-screen">
      {/* 1. Kopfbereich */}
      <header className="h-screen flex flex-col items-center justify-center px-6 text-center">
        <img 
          src="https://github.com/mike3011/Bilder/blob/main/Logo%20Under%20Open%20Sky%20(1).png?raw=true" 
          alt="Under Open Sky Logo" 
          className="w-24 h-auto mb-8 opacity-90"
        />
        <h1 className="text-4xl md:text-5xl mb-4">Under Open Sky</h1>
        <p className="text-lg text-gray-500">Ein Framework für Projekte unter freiem Himmel.</p>
      </header>

      {/* Hero Image 1 */}
      <div className="image-container">
        <img 
          src="https://github.com/mike3011/Bilder/blob/main/Underopensky.JPG?raw=true" 
          alt="Waldlandschaft unter offenem Himmel" 
        />
      </div>

      <div className="text-content px-6">
        {/* 2. Abschnitt – Was das ist */}
        <section className="section-spacing">
          <p>
            <span className="italic opacity-80">Under Open Sky</span> bietet Raum für verschiedene Vorhaben in der Natur. 
            Die Projekte finden unter freiem Himmel statt. 
            Der Schwerpunkt liegt in der Region um Kassel. 
            Inhalte und Abläufe ergeben sich aus der jeweiligen Situation.
          </p>
        </section>

        {/* 3. Abschnitt – Was das nicht ist */}
        <section className="section-spacing border-t border-gray-100">
          <ul className="space-y-2 list-none p-0">
            <li>– kein Retreat</li>
            <li>– kein Coaching</li>
            <li>– kein Seminar</li>
            <li>– keine Selbstoptimierung</li>
            <li>– kein Heilsversprechen</li>
          </ul>
        </section>
      </div>

      {/* Image 2 */}
      <div className="image-container">
        <img 
          src="https://github.com/mike3011/Bilder/blob/main/20250725_164257.jpg?raw=true" 
          alt="Naturaufnahme" 
        />
      </div>

      <div className="text-content px-6">
        {/* 4. Abschnitt – Aktuelle Projekte */}
        <section className="section-spacing border-t border-gray-100">
          <div className="space-y-16">
            <div>
              <h3 className="text-xl mb-4 text-gray-800">Nature Your Mind, Mind Your Nature</h3>
              <p>Zeit im Wald zur Beobachtung von Umgebung und Gedanken.</p>
            </div>
            
            <div>
              <h3 className="text-xl mb-4 text-gray-800">Yin & Klang in der Natur</h3>
              <p>Ruhige Körperpraxis mit Klangschalen an wechselnden Plätzen im Freien.</p>
            </div>
            
            <div>
              <h3 className="text-xl mb-4 text-gray-800">Village – Genuss unter freiem Himmel</h3>
              <p>Qualitativ hochwertige, handwerklich hergestellte Genüsse, dort, wo Menschen sich aufhalten.</p>
            </div>

            <div>
              <h3 className="text-xl mb-4 text-gray-800">Horizon</h3>
              <p>Zeit auf dem Wasser. Fahren, treiben, schauen – bis sich Horizont und Bewegung nicht mehr trennen lassen.</p>
            </div>
          </div>
          
          <p className="text-sm text-gray-400 mt-20 italic">
            Diese Projekte sind eine Momentaufnahme und können sich verändern.
          </p>
        </section>

        {/* 5. Kontakt */}
        <section className="section-spacing border-t border-gray-100 text-center">
          <p className="text-gray-800">mike@underopensky.de</p>
        </section>
      </div>

      {/* Image 3 */}
      <div className="image-container">
        <img 
          src="https://github.com/mike3011/Bilder/blob/main/20250901_102233.jpg?raw=true" 
          alt="Naturaufnahme Abschluss" 
        />
      </div>

      {/* Footer */}
      <footer className="py-20 bg-white border-t border-gray-50">
        <div className="max-w-4xl mx-auto px-6 flex justify-center space-x-12 text-xs uppercase tracking-widest text-gray-400">
          <Link to="/impressum" className="hover:text-gray-800 transition-colors">Impressum</Link>
          <Link to="/datenschutz" className="hover:text-gray-800 transition-colors">Datenschutz</Link>
        </div>
      </footer>
    </div>
  );
};

export default Home;